<template>
    <BaseInput
        v-slot="{field}"
        v-model="proxyInputValue"
        required
        hide-label
        :name="name"
        :label="label"
        :rules="rules">
        <textarea
            ref="textareaInput"
            v-bind="field"
            :placeholder="$t('core.inputOwnAnswer')"
            class="form-control"
            rows="2"
            @click.stop />
    </BaseInput>
</template>

<script>
export default {
    name: "CardSelectItemCustomInput",
    props: {
        modelValue: {
            required: true
        },
        rules: {
            type: Object
        },
        name: {
            type: String
        },
        label: {
            type: String
        }
    },
    computed: {
        proxyInputValue: {
            get() {
                return this.modelValue
            },
            set(value) {
                this.$emit('update:modelValue', value)
            }
        }
    },
    mounted() {
        // this.$refs.textareaInput.focus()
    }
}
</script>

<style scoped>

</style>
